import * as React from 'react';
import { useTheme } from '../../../theme';
import cn from 'classnames';

interface Props {
	className?: string;
}
const SummaryGroup: React.FC<Props> = ({ className, children }) => {
	const theme = useTheme('PaymentForm').Summary;

	return <div className={cn(theme.group, className)}>{children}</div>;
};

export default SummaryGroup;
